import type { Side } from '../../../../../../../../../../../../enums/side'
import { postRequest } from '../../../../../../../../../../../../utils'

export interface CreateContactPaymentPayload {
  cashAccountId: string
  cashAmount: number
  cashSide: Side
  contactId: string
  entryDate: string
  organizationId: string
  subjectCurrencyId: string
}

export const createContactPayment = (payload: CreateContactPaymentPayload): Promise<void> =>
  postRequest('/v2/bankPayments', { bankPayment: payload })
